import { Routes, CanDeactivate } from '@angular/router';
import { LoginFormComponent } from './components/UI/login-form/login-form.component';
import { SplashComponent } from './components/shared/splash/splash.component';
import { SubscriptionErrorComponent } from './components/subscription-error/subscription-error.component';
import { ResetPasswordComponent } from './components/UI/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './components/UI/forgot-password/forgot-password.component';
import { InventoryProductsComponent } from './components/UI/inventory-dashboard/inventory-products/inventory-products.component';
import { InventoryRawMaterialsComponent } from './components/UI/inventory-dashboard/inventory-raw-materials/inventory-raw-materials.component';
import { ReportsDashboardComponent } from './components/UI/reports-dashboard/reports-dashboard.component';
import { CostCalculatorComponent } from './components/UI/cost-calculator/cost-calculator.component';
import { CostingDashboardComponent } from './components/UI/costing-dashboard/costing-dashboard.component';
import { BusinessFormComponent } from './components/UI/business-details/business-form.component';
import { ManufacturingSupplyChainDashboardComponent } from './components/UI/manufacturing-supply-chain-dashboard/manufacturing-supply-chain-dashboard.component';
import { RegistrationComponent } from './components/UI/registration/registration.component';
import { AlertComponent } from './components/shared/reusables/alert/alert.component';
import { ConfigComponent } from './components/UI/config/config.component';
import { RenewalModalComponent } from './components/shared/renewal-modal/renewal-modal.component';
import { MainDashboardComponent } from './components/UI/main-dashboard/main-dashboard.component';
import { SageConnectComponent } from './components/UI/sage-integration/sage-connect.component';
import { SageOverviewComponent } from './components/UI/sage-integration/sage-overview.component';
import { SageEntityDetailComponent } from './components/UI/sage-integration/sage-entity-detail.component';
import { SageConsoleComponent } from './components/UI/sage-integration/sage-console.component';
import { SetupGuard } from './guards/setup.guard';
import { AccountTypeGuard } from './guards/account-type.guard';
import { AuthGuard } from './guards/auth.guard';
import { MobileGuard } from './guards/mobile.guard';
import { SageAccessGuard } from './guards/sage-access.guard';
export const routes: Routes = [
  { path: 'login', component: LoginFormComponent, data: { title: 'Login' } },
  { path: '', component: LoginFormComponent, data: { title: 'Login' } },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: { title: 'Forgot Password' },
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: { title: 'Reset Password' },
  },
  {
    path: 'dashboard',
    component: MainDashboardComponent,
    data: { title: 'Main Dashboard' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'inventory',
    redirectTo: 'inventory/products',
    pathMatch: 'full',
  },
  {
    path: 'inventory/products',
    component: InventoryProductsComponent,
    data: { title: 'Products' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'inventory/raw-materials',
    component: InventoryRawMaterialsComponent,
    data: { title: 'Raw Materials' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },

  {
    path: 'calc',
    component: CostCalculatorComponent,
    data: { title: 'Cost Calculator' },
    canActivate: [AuthGuard, SetupGuard],
    canDeactivate: [
      (component: CostCalculatorComponent) => component.canDeactivate(),
    ],
  },
  {
    path: 'reports',
    component: ReportsDashboardComponent,
    data: { title: 'Reports Dashboard' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'costing',
    component: CostingDashboardComponent,
    data: { title: 'Costing & Budgeting Dashboard' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'business-details',
    component: BusinessFormComponent,
    data: { title: 'Business Details' },
    canActivate: [AuthGuard],
  },
  {
    path: 'manufacturing',
    component: ManufacturingSupplyChainDashboardComponent,
    data: { title: 'Manufacturing & Supply Chain' },
    canActivate: [AuthGuard, SetupGuard, AccountTypeGuard, MobileGuard],
  },
  {
    path: 'register',
    component: RegistrationComponent,
    data: { title: 'Registration' },
  },
  { path: 'alert', component: AlertComponent, data: { title: 'alert' } },
  {
    path: 'config',
    component: ConfigComponent,
    data: { title: 'Configurations' },
    canActivate: [AuthGuard],
  },
  {
    path: 'sage-integration',
    component: SageConnectComponent,
    data: { title: 'Sage Integration' },
    canActivate: [AuthGuard, SageAccessGuard],
  },
  {
    path: 'settings/integrations',
    component: SageConnectComponent,
    data: { title: 'Sage Integration' },
    canActivate: [AuthGuard, SageAccessGuard],
  },
  {
    path: 'sage-integration/overview',
    component: SageOverviewComponent,
    data: { title: 'Sage Integration' },
    canActivate: [AuthGuard, SageAccessGuard],
  },
  {
    path: 'sage-integration/console',
    component: SageConsoleComponent,
    data: { title: 'Sage Integration' },
    canActivate: [AuthGuard, SageAccessGuard],
  },
  {
    path: 'sage-integration/:entityType',
    component: SageEntityDetailComponent,
    data: { title: 'Sage Integration' },
    canActivate: [AuthGuard, SageAccessGuard],
  },
  {
    path: 'subscription-error',
    component: SubscriptionErrorComponent,
    data: { title: 'Subscription Error' },
  },
  {
    path: 'renewal',
    component: RenewalModalComponent,
    data: { title: 'Subscription Renewal' },
  },
];
